import styles from './App.module.css'
import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { Home } from './container/Home'
import { UserSignIn } from './container/SignIn'
import { UserSignUp } from './container/SignUp'
import { User } from './container/User'
import { ProtectedRoute } from './components/ProtectedRoutes'
import { EditProfile } from './container/EditProfile'
import { Nav } from './container/Nav'
import { Search } from './container/Search'
import logo from './images/logo.svg'
import { FiHelpCircle } from 'react-icons/fi'
import { News } from './container/News'
import { auth } from './firebase-config'
import { CreateNews } from './container/CreateNews'
import { InfoOverlay } from './components/InfoOverlay'
import { Button } from './components/Button'
import { InfoOverlayContent } from './container/InfoOverlayContent'
import { ToastContainer } from 'react-toastify'
import { ImpressumContent } from './container/ImpressumContent'
import { PasswordReset } from './components/PasswordReset'

export const App = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const [loggedInUser, setLoggedInUser] = useState()
  const [wasUserLoaded, setWasUserLoaded] = useState(false)

  useEffect(() => {
    auth.onAuthStateChanged((loggedInUser) => {
      setLoggedInUser(loggedInUser)
      setWasUserLoaded(true)
    })
  }, [])

  const getPagetitle = () => {
    let title = ''
    switch (location.pathname) {
      case '/': {
        title = 'Startseite'
        break
      }
      case '/search': {
        title = 'Suche'
        break
      }
      case '/news': {
        title = 'Neuigkeiten'
        break
      }
      case '/create-news': {
        title = 'Beitrag'
        break
      }
      case '/user': {
        title = 'Benutzer'
        break
      }
      case '/sign-in': {
        title = 'Login'
        break
      }
      case '/sign-up': {
        title = 'Registrieren'
        break
      }
      case '/edit-profile': {
        title = 'Profil'
        break
      }
      case '/password-reset': {
        title = 'Passwort vergessen'
        break
      }
      default: {
        window.location.replace('/')
      }
    }
    return title
  }

  const [pagetitle, setPagetitle] = useState(getPagetitle())

  useEffect(() => {
    const title = getPagetitle()
    setPagetitle(title)
    if (!location.hash) {
      window.scrollTo({ top: 0 })
    } else if (location.hash === '#shop-container') {
      window.scrollTo(0, document.body.scrollHeight)
    }
  }, [location])

  const [infoOverlay, setInfoOverlay] = useState(false)
  const [impressum, setImpressum] = useState(false)

  return (
    <>
      <div className={styles.container}>
        <header>
          <FiHelpCircle
            onClick={() => {
              setInfoOverlay(!infoOverlay)
            }}
            className={styles.help}
          />
          <InfoOverlay isOpen={infoOverlay}>
            {!impressum ? (
              <>
                <InfoOverlayContent />
                <div className={styles.buttonContainer}>
                  <Button onClick={() => setImpressum(true)}>Impressum</Button>
                  <Button onClick={() => setInfoOverlay(false)}>
                    schließen
                  </Button>
                </div>
              </>
            ) : (
              <>
                <ImpressumContent />
                <div className={styles.buttonContainer}>
                  <Button onClick={() => setImpressum(false)}>Hilfe</Button>
                  <Button onClick={() => setInfoOverlay(false)}>
                    schließen
                  </Button>
                </div>
              </>
            )}
          </InfoOverlay>

          <h1>{pagetitle}</h1>
          <img
            src={logo}
            alt="Logo"
            onClick={() => {
              navigate('/')
            }}
          />
        </header>
        <Nav/>
        <Routes>
          <Route path="/search" element={<Search />}></Route>
          <Route path="/news" element={<News user={loggedInUser} />}></Route>
          <Route path="/create-news" element={<CreateNews />}></Route>
          <Route path="/user" element={<User user={loggedInUser} />}></Route>
          <Route
            exact
            path="/sign-in"
            element={<UserSignIn user={loggedInUser} />}
          ></Route>
          <Route
            path="/sign-up"
            element={<UserSignUp user={loggedInUser} />}
          ></Route>
          <Route
            path="/edit-profile"
            element={
              <ProtectedRoute user={loggedInUser} wasUserLoaded={wasUserLoaded}>
                <EditProfile />
              </ProtectedRoute>
            }
          ></Route>
          <Route path="/password-reset" element={<PasswordReset />}></Route>
          <Route path="/" element={<Home />}></Route>
        </Routes>
      </div>
      <ToastContainer position="top-center" />
    </>
  )
}
